import { render } from "./CampaignsWall.vue?vue&type=template&id=aafdafb4"
import script from "./CampaignsWall.vue?vue&type=script&lang=js"
export * from "./CampaignsWall.vue?vue&type=script&lang=js"
script.render = render

export default script